import React, { useEffect, useRef, useState } from "react";
import "./Courses.css";
import button1 from "../../../../assets/images/Courses/Group 39223.png";
import button2 from "../../../../assets/images/Courses/Group 39222.png";
import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";
import OwlCarousel from "react-owl-carousel2";
import "./Owl.css"; 

function Course1({ allcourse, setcourse }) {
  const [activeid, setactiveid] = useState("");
  const { t } = useTranslation();
  const [autoPlay, setautoPlay] = useState(false);

  const handleItemClick = (index) => {
    setactiveid(index);
  };
  const options = {
    items: 3,
    nav: true,
    rewind: true,
    loop: false,
    autoplay: autoPlay,
    autoplayTimeout: 2000,
    startPosition: 1,
    responsive: {
      0: {
        items: 1,
      },
      300: {
        items: 1,
      },
      360: {
        items: 1,
      },
      400: {
        items: 1,
      },
      720: {
        items: 2,
      },
      800: {
        items: 2,
      },
      1050: {
        items: 3,
      },
      1200: {
        items: 3,
      },
      1400: {
        items: 4,
      },
      1600: {
        items: 4,
      },
    },
  };

  return (
    <div className="courseMain">
      <div className="owl-div">
        <OwlCarousel options={options} navcontainer={".owl-nav"}>
          {allcourse.length ? (
            allcourse.map((item, index) => (
              <div
                key={item.id}
                id={`${activeid === index ? "activeID" : ""}`}
                className="carousel-box"
                onClick={() => {
                  setcourse(item.id);
                  handleItemClick(index);
                }}
              >
                <p className="carousel-box-text"> {item.name}</p>
              </div>
            ))
          ) : (
            <>
              <Skeleton variant="rectangular" width={`100%`} height={60} />
            </>
          )}
        </OwlCarousel>
      </div>
    </div>
  );
}

export default Course1;
